import DOMPurify from "dompurify";
import { marked } from "marked";

export const renderMarkdownToHtml = (content: string): string => {
  if (content.trim().length === 0) {
    return "";
  }

  const html = marked.parse(content, { breaks: true }) as string;
  return DOMPurify.sanitize(html);
};
